<template>
  <b-card header="Logs de Comissoes">
    <StateRenderer :loading="report.loading" :error="report.error" :data="logs">
      <b-alert
        v-if="logs.length === 0"
        show
        variant="secondary"
        class="text-center"
      >
        Nenhum log encontrado no periodo selecionado
      </b-alert>
      <template v-else>
        <b-table :fields="fields" :items="logs" striped hover small responsive>
          <template #cell(createdAt)="{ item }">
            {{ item.createdAt | formatStandardDateTime }}
          </template>
          <template #cell(reason)="{ item }">
            {{ formatReason(item.reason) }}
          </template>
        </b-table>
      </template>
    </StateRenderer>
  </b-card>
</template>

<script>
import StateRenderer from '@/components/StateRenderer'
import { formatStandardDateTime } from '@/helpers/date'

const REASON_LABELS = {
  rent_started: 'Aluguel iniciado',
  rent_closed: 'Aluguel encerrado',
  rent_rescued: 'Aluguel resgatado',
  product_sale: 'Venda de produto',
  manual_adjustment: 'Ajuste manual'
}

export default {
  name: 'CommissionsLogList',
  components: { StateRenderer },
  filters: {
    formatStandardDateTime
  },
  props: {
    report: {
      type: Object,
      required: true
    }
  },
  computed: {
    fields() {
      return [
        { key: 'createdAt', label: 'Data' },
        { key: 'userName', label: 'Funcionario' },
        { key: 'points', label: 'Vendas' }
        // { key: 'reason', label: 'Motivo' },
        // { key: 'rentId', label: 'Aluguel' }
      ]
    },
    logs() {
      const data = this.report?.data || {}
      if (Array.isArray(data.logs)) return data.logs
      if (Array.isArray(data)) return data
      return []
    }
  },
  methods: {
    formatReason(reason) {
      return REASON_LABELS[reason] || reason || '-'
    }
  }
}
</script>
